module.exports = "static/assets/223d68e7b8769bac1f33291514ce5bac.svg";